module.exports = __webpack_public_path__ + "media/1alB-ch-chuhd.13afd327.mp3";